// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailIsUnsubscribedDefaultResponse {
    static getAttributeTypeMap() {
        return EmailIsUnsubscribedDefaultResponse.attributeTypeMap;
    }
}
EmailIsUnsubscribedDefaultResponse.discriminator = undefined;
EmailIsUnsubscribedDefaultResponse.additionalProperties = false;
EmailIsUnsubscribedDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "boolean"
    },
];
//# sourceMappingURL=emailIsUnsubscribedDefaultResponse.js.map